module.exports = __webpack_public_path__ + "img/watage_res_6.2d98d959.gif";